var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductsEmptyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 62,
    viewBox: "0 0 64 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9879_436233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7101 61.8503H50.8125V31.5H53.9823C54.1359 31.5 54.2831 31.5615 54.392 31.6711C54.5008 31.7806 54.5623 31.9293 54.5631 32.0847L54.7101 61.8503Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1761 62.013H9.32031V40.3984H51.1761V62.013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6773 61.9304H9.39844V40.4766H51.0954V45.3194C51.0904 49.7234 49.3591 53.9456 46.2812 57.0597C43.2033 60.1738 39.0302 61.9254 34.6773 61.9304V61.9304Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0759 32.3621C54.0549 32.4024 54.0386 32.445 54.0273 32.489L52.584 38.1176L51.0185 41.1174H9.48047V40.3702L11.8454 38.1176L14.6041 32.7787C14.7259 32.543 14.8858 32.3296 15.0773 32.1474C15.5141 31.7315 16.0913 31.5 16.6911 31.5H53.5624C53.6625 31.5 53.7609 31.5262 53.8481 31.576C53.9352 31.6258 54.0082 31.6976 54.0598 31.7843C54.1115 31.871 54.1401 31.9698 54.143 32.0711C54.1458 32.1723 54.1227 32.2726 54.0759 32.3621V32.3621Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1761 62.013H9.32031V40.3984H51.1761V62.013ZM9.63805 61.6916H50.8584V40.7199H9.63805V61.6916Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3534 35.2422L52.5823 38.1184H11.8438L13.1601 35.7244L53.3534 35.2422Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5394 51.7188H10.8672V52.0923H17.5394V51.7188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5394 53.0312H10.8672V53.4048H17.5394V53.0312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5394 54.3438H10.8672V54.7173H17.5394V54.3438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4468 47.5595C14.7723 47.5595 15.8468 46.4723 15.8468 45.1313C15.8468 43.7903 14.7723 42.7031 13.4468 42.7031C12.1214 42.7031 11.0469 43.7903 11.0469 45.1313C11.0469 46.4723 12.1214 47.5595 13.4468 47.5595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7531 36.4812H37.7148V20.6094H39.3725C39.4528 20.6094 39.5298 20.6415 39.5867 20.6988C39.6437 20.7561 39.6758 20.8339 39.6762 20.9151L39.7531 36.4812Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9082 36.5691H16.0195V25.2656H37.9082V36.5691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2783 36.5319H16.0586V25.3125H37.8642V27.8451C37.8616 30.1482 36.9562 32.3562 35.3466 33.9847C33.737 35.6132 31.5546 36.5293 29.2783 36.5319Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4229 21.0602C39.4119 21.0813 39.4034 21.1035 39.3975 21.1266L38.6427 24.0701L37.824 25.6388H16.1016V25.2481L17.3383 24.0701L18.781 21.2781C18.8447 21.1548 18.9283 21.0432 19.0284 20.9479V20.9479C19.2569 20.7305 19.5587 20.6094 19.8724 20.6094H39.1544C39.2067 20.6094 39.2582 20.6231 39.3037 20.6491C39.3493 20.6752 39.3875 20.7127 39.4145 20.7581C39.4415 20.8034 39.4565 20.8551 39.458 20.908C39.4594 20.961 39.4474 21.0134 39.4229 21.0602V21.0602Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9082 36.5691H16.0195V25.2656H37.9082V36.5691ZM16.1857 36.4009H37.742V25.4337H16.1857V36.4009Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0474 22.5781L38.6442 24.0821H17.3398L18.0282 22.8302L39.0474 22.5781Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3135 31.1875H16.8242V31.3829H20.3135V31.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3135 31.875H16.8242V32.0704H20.3135V31.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3135 32.5547H16.8242V32.75H20.3135V32.5547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1769 29.0162C18.8701 29.0162 19.432 28.4477 19.432 27.7464C19.432 27.0451 18.8701 26.4766 18.1769 26.4766C17.4838 26.4766 16.9219 27.0451 16.9219 27.7464C16.9219 28.4477 17.4838 29.0162 18.1769 29.0162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6965 61.9114C58.6965 61.945 58.6939 61.9782 58.6889 62.0092C58.6838 62.0402 58.6764 62.0684 58.6671 62.0921C58.6577 62.1158 58.6466 62.1346 58.6344 62.1474C58.6221 62.1602 58.609 62.1667 58.5958 62.1666H4.78423C4.75754 62.1666 4.73194 62.1397 4.71307 62.0918C4.6942 62.044 4.68359 61.9791 4.68359 61.9114C4.68359 61.8437 4.6942 61.7788 4.71307 61.731C4.73194 61.6831 4.75754 61.6563 4.78423 61.6563H58.5958C58.609 61.6562 58.6221 61.6627 58.6344 61.6755C58.6466 61.6883 58.6577 61.7071 58.6671 61.7308C58.6764 61.7545 58.6838 61.7827 58.6889 61.8137C58.6939 61.8447 58.6965 61.8779 58.6965 61.9114Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.48 25.1422C13.0166 25.1067 11.5993 25.6607 10.5397 26.6825C9.48007 27.7043 8.86506 29.11 8.82992 30.5906C8.75675 33.6737 10.9264 40.16 14.0646 42.6444C14.969 37.2648 19.4776 33.7181 19.865 30.8587C20.279 27.8033 17.5272 25.2163 14.48 25.1422Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9133 32.0251C14.9074 32.0251 15.7132 31.2097 15.7132 30.2039C15.7132 29.1982 14.9074 28.3828 13.9133 28.3828C12.9192 28.3828 12.1133 29.1982 12.1133 30.2039C12.1133 31.2097 12.9192 32.0251 13.9133 32.0251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2336 45.3465C13.8847 45.3465 14.4126 44.8125 14.4126 44.1537C14.4126 43.495 13.8847 42.9609 13.2336 42.9609C12.5825 42.9609 12.0547 43.495 12.0547 44.1537C12.0547 44.8125 12.5825 45.3465 13.2336 45.3465Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.2818 28.7697C15.7111 28.981 16.0398 29.3562 16.1957 29.8127C16.3516 30.2692 16.3218 30.7697 16.113 31.204C16.0096 31.419 15.8653 31.6114 15.6885 31.77C15.5116 31.9287 15.3056 32.0505 15.0822 32.1286C14.631 32.2863 14.1363 32.2562 13.707 32.0449C14.1308 32.1012 14.5605 32.0031 14.9193 31.7681C15.2781 31.5332 15.5425 31.1767 15.6652 30.7625C15.788 30.3483 15.761 29.9034 15.5892 29.5075C15.4173 29.1115 15.1118 28.7904 14.7273 28.6016C14.9199 28.627 15.1072 28.6838 15.2818 28.7697V28.7697Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.8734 30.8569C19.486 33.7163 14.9774 37.2631 14.073 42.6427C13.7776 42.4065 13.4999 42.1486 13.2422 41.8711C14.343 36.792 18.5642 33.3874 18.9385 30.6247C19.2735 28.1521 17.535 25.9864 15.2446 25.2109C17.9735 25.6507 20.2528 28.057 19.8734 30.8569Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8438 21.9828H23.0826V12.3359H22.0751C22.0263 12.3359 21.9795 12.3555 21.9449 12.3903C21.9103 12.4251 21.8907 12.4724 21.8905 12.5218L21.8438 21.9828Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 15.1641H36.2726V22.0343H22.9688V15.1641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9922 16.7268V15.1875H36.2456V22.0066H28.2107C26.8271 22.005 25.5007 21.4483 24.5224 20.4584C23.5441 19.4686 22.9938 18.1266 22.9922 16.7268Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0487 12.61C22.0554 12.6227 22.0606 12.6363 22.0642 12.6503L22.5229 14.4393L23.0205 15.3928H36.2234V15.1553L35.4717 14.4394L34.5948 12.7424C34.5561 12.6675 34.5053 12.5996 34.4444 12.5417V12.5417C34.3056 12.4095 34.1221 12.3359 33.9315 12.3359H22.2119C22.1801 12.3359 22.1488 12.3443 22.1211 12.3601C22.0934 12.3759 22.0703 12.3987 22.0538 12.4263C22.0374 12.4539 22.0283 12.4853 22.0274 12.5174C22.0265 12.5496 22.0339 12.5815 22.0487 12.61Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 15.1641H36.2726V22.0343H22.9688V15.1641ZM36.1716 21.9321H23.0697V15.2662H36.1716L36.1716 21.9321Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2773 13.5312L22.5225 14.4455H35.4712L35.0528 13.6846L22.2773 13.5312Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7809 18.7656H33.6602V18.8844H35.7809V18.7656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7809 19.1797H33.6602V19.2984H35.7809V19.1797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7809 19.5938H33.6602V19.7125H35.7809V19.5938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9621 17.442C35.3834 17.442 35.7249 17.0965 35.7249 16.6702C35.7249 16.244 35.3834 15.8984 34.9621 15.8984C34.5408 15.8984 34.1992 16.244 34.1992 16.6702C34.1992 17.0965 34.5408 17.442 34.9621 17.442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8055 5.00099C29.7022 4.97921 30.5707 5.3187 31.2199 5.94478C31.8692 6.57086 32.246 7.43224 32.2676 8.33943C32.3124 10.2286 30.983 14.2031 29.06 15.7254C28.5059 12.429 25.7432 10.2558 25.5059 8.5037C25.2522 6.63153 26.9383 5.04635 28.8055 5.00099Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1537 9.23177C29.7628 9.23177 30.2566 8.73217 30.2566 8.11589C30.2566 7.4996 29.7628 7 29.1537 7C28.5446 7 28.0508 7.4996 28.0508 8.11589C28.0508 8.73217 28.5446 9.23177 29.1537 9.23177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.57 17.3915C29.969 17.3915 30.2924 17.0642 30.2924 16.6606C30.2924 16.2569 29.969 15.9297 29.57 15.9297C29.1711 15.9297 28.8477 16.2569 28.8477 16.6606C28.8477 17.0642 29.1711 17.3915 29.57 17.3915Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.3158 7.23586C28.1855 7.29996 28.069 7.38939 27.9729 7.49904C27.8769 7.60869 27.8031 7.73642 27.7558 7.87492C27.7085 8.01342 27.6886 8.16 27.6973 8.30627C27.706 8.45254 27.7431 8.59565 27.8064 8.72742C27.8698 8.8592 27.9582 8.97705 28.0666 9.07427C28.1749 9.17148 28.3012 9.24614 28.4381 9.29399C28.575 9.34184 28.7198 9.36194 28.8644 9.35315C29.009 9.34435 29.1504 9.30683 29.2807 9.24273C29.021 9.27722 28.7577 9.2171 28.5379 9.07312C28.318 8.92914 28.156 8.7107 28.0808 8.4569C28.0056 8.2031 28.0221 7.9305 28.1274 7.6879C28.2327 7.4453 28.4199 7.24853 28.6555 7.13281C28.5375 7.14839 28.4228 7.18319 28.3158 7.23586V7.23586Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.5059 8.51424C25.7432 10.2663 28.5059 12.4396 29.06 15.7359C29.241 15.5912 29.4112 15.4332 29.5691 15.2631C28.8946 12.1509 26.3081 10.0648 26.0787 8.37197C25.8735 6.85684 26.9387 5.52984 28.3421 5.05469C26.67 5.32416 25.2734 6.79857 25.5059 8.51424Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9879_436233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 62,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsEmptyIcon);
export default __webpack_public_path__ + "static/media/products_empty_icon.bdea636eec5f2b5960852dfffb8d8f54.svg";
export { ForwardRef as ReactComponent };